import React from 'react';
import { t } from '@lingui/macro';

import { Text } from '@rover/kibble/core';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';

import { useRevampProfileContext } from '../../hooks/useRevampProfileContext';
import AccordionSection from '../AccordionSection/AccordionSection';

import { SitterProfileWhatSitterWantsToKnowExpandEvent } from './analyticsEvents';

const WhatSitterWantsToKnowSection = (): JSX.Element | null => {
  const { sitterData } = useRevampProfileContext();

  const requestedDogInfo = sitterData.providerProfile?.requestedDogInfo;

  if (!requestedDogInfo) return null;

  const sitterName = sitterData.firstName;
  const isPluralAccount = sitterData.providerProfile?.isPluralAccount ?? false;
  const sectionTitle = isPluralAccount
    ? t`What ${sitterName} want to know`
    : t`What ${sitterName} wants to know`;

  return (
    <AccordionSection
      sectionName="requested-dog-info"
      title={sectionTitle}
      onExpand={() => emitAnalyticsEvent(new SitterProfileWhatSitterWantsToKnowExpandEvent())}
      body={<Text size="200">{requestedDogInfo}</Text>}
    />
  );
};

export default WhatSitterWantsToKnowSection;
